// extracted by mini-css-extract-plugin
module.exports = {"icon":"NotificationButton_icon__18Hcr","badge":"NotificationButton_badge__2SSaA"};